import { render, staticRenderFns } from "./ListaCompraLogs.vue?vue&type=template&id=0f46fdcd"
import script from "./ListaCompraLogs.vue?vue&type=script&lang=js"
export * from "./ListaCompraLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports